module.exports = __webpack_public_path__ + "static/img/image.29a2dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/landingPage/image.png
// module id = p179
// module chunks = 0